import React, { Component } from "react";
import "../../styles/maps/map.scss";
import { utcToLocal } from "../../utils/dateConvert";
import { offsetMapLocation, drawDepot } from "../../utils/map";
import { here_api_key } from "../../utils/mapapi";
import $ from "jquery";
import { temperatureReadingMarkup } from "../../utils/temperature";

class VisitMap extends Component {

  constructor(props) {
    super(props);
    this.state = {
      scrollLockEnabled: localStorage.getItem("visitMapScrollLock") !== "false",
      popupDocked: localStorage.getItem("visitNewPopupDocked") === "true",
      dockedPopupContent: null,
      exceptionsVisible: false,
    };
    this.routeGroup = null;
    this.subTripGroup = null;
    this.selectedRouteGroup = null;
    this.depotGroup = null;
    this.exceptionGroup = null;
    this.mapBehaviour = null;
    this.scrollTimer = null;
    this.ctrlDown = false;
    this.isMouseOverMap = false;
  }

  // Create SVG Flag marker
  createFlagMarker(markerName, selected = false) {
    return `<svg width="56" height="49" viewBox="0 0 48 42" xmlns="http://www.w3.org/2000/svg">
    <g >
     <path d="m7.03553,3.53539q0,1.93944 -1.70025,2.96303l0,34.10183q0,0.35017 -0.25238,0.60608t-0.59775,0.25589l-1.70025,0q-0.34536,0 -0.59775,-0.25589t-0.25238,-0.60608l0,-34.10183q-1.70025,-1.02359 -1.70025,-2.96303q0,-1.42765 0.99624,-2.43777t2.40426,-1.01012t2.40426,1.01012t0.99624,2.43777l0,0l0.00001,0zm39.10578,1.72394l0,20.55268q0,0.67342 -0.33208,1.03706t-1.04937,0.74075q-5.71178,3.12465 -9.80302,3.12465q-1.62056,0 -3.28096,-0.59261t-2.88246,-1.29296t-3.06843,-1.29296t-3.78571,-0.59261q-5.10076,0 -12.32682,3.93276q-0.45162,0.24244 -0.8767,0.24244q-0.69073,0 -1.1955,-0.5118t-0.50477,-1.21216l0,-19.98701q0,-0.86197 0.82357,-1.48152q0.5579,-0.37711 2.09875,-1.15828q6.26968,-3.2324 11.18447,-3.2324q2.84261,0 5.31329,0.78115t5.81805,2.37042q1.00952,0.5118 2.33784,0.5118q1.43458,0 3.12156,-0.56568t2.9223,-1.26603t2.33784,-1.26603t1.44787,-0.56568q0.69073,0 1.1955,0.5118t0.50477,1.21216l0,0l0,0.00002l0.00001,0.00004z" fill="${selected ? "#ff5a4f" : "#6AB36A"}" fill-opacity=".85" />
     <text font-weight="bold" xml:space="preserve"  alignment-baseline="middle" text-anchor="middle" font-family="Helvetica, Arial, sans-serif" font-size="16" id="svg_4" y="50%" x="50%" fill-opacity="null" stroke-opacity="null" stroke-width="0" stroke="null" fill="#000000">${markerName}</text>
    </g>
   </svg>`;
  }

  createExceptionMarker(speedLimit, selected = false) {
    const border = selected ? "#7f1d1d" : "#ed1c24";
    const numericSpeedLimit = Number(speedLimit);
    const value = speedLimit == null || speedLimit === "" || !Number.isFinite(numericSpeedLimit) ? "!" : Math.round(numericSpeedLimit);
    const fontSize = String(value).length > 2 ? 12 : 15;
    return `<svg width="40" height="55" viewBox="0 0 48 66" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="24" cy="63" rx="8" ry="2.5" fill="rgba(15,23,42,.25)"/>
      <rect x="21" y="36" width="6" height="27" rx="2" fill="#6b7280" stroke="#fff" stroke-width="1.5"/>
      <rect x="4" y="2" width="40" height="40" rx="4" fill="#fff" stroke="${selected ? "#1d4ed8" : "#475569"}" stroke-width="${selected ? 3 : 1.5}"/>
      <circle cx="24" cy="22" r="15" fill="#fff" stroke="${border}" stroke-width="5"/>
      <text x="24" y="27" text-anchor="middle" font-family="Arial,sans-serif" font-size="${fontSize}" font-weight="800" fill="#111827">${value}</text>
    </svg>`;
  }
  // Create Start pin
  createStartMarker() {
    return `<svg width="40" height="64" version="1.1" viewBox="0 0 10.583 16.933" xmlns="http://www.w3.org/2000/svg">
    <g transform="matrix(1.0608 0 0 1.0608 -1.9236 -.4301)">
      <g transform="matrix(.56129 0 0 .56129 -455.16 -156.95)">
        <path d="m817.11 282.97c-1.2582 1.3428-2.0462 3.2988-2.0156 5.1387 0.0639 3.8448 1.7969 5.3002 4.5684 10.592 0.99832 2.3285 2.0403 4.7924 3.0312 8.873 0.13772 0.60193 0.27203 1.161 0.33416 1.2095 0.0621 0.0485 0.19644-0.51262 0.33416-1.1146 0.99098-4.0807 2.0329-6.5426 3.0312-8.8711 2.7714-5.2916 4.5044-6.747 4.5684-10.592 0.0306-1.8399-0.75942-3.7978-2.0176-5.1406-1.4372-1.5339-3.605-2.6691-5.9162-2.7166s-4.4809 1.0877-5.9181 2.6216z" fill="#70B7CC" fill-opacity=".7" stroke="#000" stroke-width=".28707"/>
        <text x="819.55414" y="292.56235" fill="#ffffff" font-family="sans-serif" font-size="10.056px" stroke-width=".47138" style="font-variant-caps:normal;font-variant-east-asian:normal;font-variant-ligatures:normal;font-variant-numeric:normal;line-height:1.25" xml:space="preserve"><tspan x="819.55414" y="292.56235" fill="#ffffff" font-family="sans-serif" font-size="10.056px" stroke-width=".47138" style="font-variant-caps:normal;font-variant-east-asian:normal;font-variant-ligatures:normal;font-variant-numeric:normal">S</tspan></text>
      </g>
    </g>
  </svg>
  `;
  }
  // Create End pin (Truck)
  createEndMarker() {
    return `<svg width="64" height="64" version="1.1" viewBox="0 0 16.933 16.933" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-107.64 -134.28)">
      <path d="m113.28 147.06q0-0.5003-0.37238-0.8659-0.37238-0.36561-0.88194-0.36561t-0.88193 0.36561q-0.37238 0.3656-0.37238 0.8659t0.37238 0.86589q0.37237 0.36562 0.88193 0.36562t0.88194-0.36562q0.37238-0.36559 0.37238-0.86589zm-3.7629-4.926h3.7629v-2.463h-1.5483q-0.12736 0-0.21558 0.0866l-1.9108 1.8761q-0.0882 0.0866-0.0882 0.21167zm12.543 4.926q0-0.5003-0.37238-0.8659-0.37236-0.36561-0.88192-0.36561-0.50957 0-0.88193 0.36561-0.37238 0.3656-0.37238 0.8659t0.37238 0.86589q0.37236 0.36562 0.88193 0.36562 0.50956 0 0.88192-0.36562 0.37238-0.36559 0.37238-0.86589zm2.5086-10.468v9.852q0 0.14432-0.039 0.25496-0.0394 0.11056-0.13232 0.178-0.0931 0.0674-0.16168 0.11072-0.0686 0.0434-0.23027 0.0578-0.16166 0.0144-0.22049 0.0192-0.0589 5e-3 -0.24987 0-0.19109-5e-3 -0.22048-5e-3 0 1.0198-0.73493 1.7414-0.73496 0.72158-1.7737 0.72158-1.0387 0-1.7737-0.72158-0.73494-0.72159-0.73494-1.7414h-3.7629q0 1.0198-0.73494 1.7414-0.73495 0.72158-1.7737 0.72158-1.0387 0-1.7736-0.72158-0.73494-0.72159-0.73494-1.7414h-0.62716q-0.0293 0-0.22048 5e-3 -0.1911 5e-3 -0.24989 0-0.0589-5e-3 -0.22049-0.0192-0.16166-0.0144-0.23029-0.0578-0.0686-0.0434-0.16164-0.11072-0.0931-0.0674-0.13232-0.178-0.039-0.11072-0.039-0.25496 0-0.25014 0.18617-0.43295 0.18621-0.1828 0.44099-0.1828v-3.0788q0-0.077-5e-3 -0.33673-5e-3 -0.25977 0-0.36561 5e-3 -0.10592 0.0245-0.33192 0.0195-0.22609 0.0637-0.35598 0.0442-0.12992 0.13728-0.29345 0.0931-0.16355 0.22049-0.28862l1.9402-1.905q0.18619-0.1828 0.49488-0.30787 0.30868-0.12512 0.57326-0.12512h1.5679v-1.8473q0-0.25014 0.1862-0.43295 0.18617-0.1828 0.44097-0.1828h10.034q0.2548 0 0.44099 0.1828 0.18617 0.18281 0.18617 0.43295z" fill="#D9534F" fill-opacity=".7" stroke-width=".0097098"/>
    </g>
  </svg>`;
  }
  // Create arrow
  createArrowMarker(angle) {
    return `<svg width="94" height="94" version="1.1" viewBox="0 0 24.871 24.871" xmlns="http://www.w3.org/2000/svg">
    <path transform="rotate(${angle}, 12.4355, 12.4355)" d="m4.705 20.534 7.7304-7.7304 7.7304 7.7304" fill="none" stroke="#1414FF" stroke-linecap="round" stroke-linejoin="round" stroke-opacity=".7" stroke-width="1.4725"/>
    </svg>`;
  }

  getVisitTypePillClass = (element) => {
    if (element.isOvernight) return "overnight";
    if (element.isCurrent) return "current";
    if ((element.visitType || "").toLowerCase().indexOf("virtual") >= 0) return "virtual";
    return "parked";
  };

  componentDidMount() {
    window.handleNext = (data, assetIndex) => {
      let truckIndexInt = parseInt(assetIndex);
      let assetIndexPass;
      if (assetIndex == this.props.subTripPoints.length - 1) {
        assetIndexPass = -1;
      } else {
        assetIndexPass = assetIndex;
      }

      let element;
      let obj = {};
      if (truckIndexInt < this.props.subTripPoints.length - 1) {
        obj = {
          lat: this.props.subTripPoints[truckIndexInt + 1].lat,
          lng: this.props.subTripPoints[truckIndexInt + 1].lng,
        };
        element = this.props.subTripPoints[truckIndexInt + 1];
      } else {
        obj = {
          lat: this.props.subTripPoints[0].lat,
          lng: this.props.subTripPoints[0].lng,
        };
        element = this.props.subTripPoints[0];
      }
      if (this.props.onItemSelect && element) {
        this.props.onItemSelect(element.name);
      }
      let instruction = `<div style="color:#2296cc;text-transform:uppercase;"><strong>${this.setTripName(
          element.name
        )}</strong></div><div class="bodyContent"><p><span>${
          element.address
        }<br><strong style="color:#55b673;">${
          element.assetName
        }</strong><br><strong>${this.props.reportMode === "trips" ? "Trip Start" : "Arrived"}</strong>: <span>${utcToLocal(
          element.arrived
        )}</span><br><strong>${this.props.reportMode === "trips" ? "Trip End" : "Departed"}</strong>: <span>${element.departed ? utcToLocal(
          element.departed
        ) : (element.isOvernight ? "After midnight" : "Current")}</span><br><strong>${this.props.reportMode === "trips" ? "Journey Time" : "Stop Duration"}</strong>: <span>${
          element.parked
        }</span>${this.props.reportMode === "trips"
          ? `<br><strong>Distance</strong>: <span>${element.distance == null ? "-" : element.distance}</span><br><strong>Odometer</strong>: <span>${element.odometerStart == null ? "-" : element.odometerStart} - ${element.odometerEnd == null ? "-" : element.odometerEnd}</span>`
          : `<br><strong>Stop Type</strong>: <span class="visit-type-pill ${this.getVisitTypePillClass(element)}">${element.visitType || "-"}</span>`}<br><strong>Fridge</strong>: <span>${
          element.fridge
        }</span><br><strong>Temp A</strong>: ${temperatureReadingMarkup(
          element.tempA
        )}<br><strong>Temp B</strong>: ${temperatureReadingMarkup(
          element.tempB
        )}</p></div><div class="info-win-nav not-pop-up"><div class="not-button" onclick="handlePrevious('${
          element.name
        }','${parseInt(assetIndexPass) + 1}')">< ${
          this.setTripNamePre(element.name, parseInt(assetIndexPass) + 1) || ''
        }</div><div class="not-button" onclick="handleNext('${element.name}','${
          parseInt(assetIndexPass) + 1
        }')">${
          this.setTripNameNext(element.name, parseInt(assetIndexPass) + 1) || ''
        } ></div></div>`;

      this.openBubble(obj, instruction);

      window.map.setCenter(offsetMapLocation(window.map, { lat: element.lat, lng: element.lng }, { y: -150 }));
    };

    window.handlePrevious = (data, assetIndex) => {
      let truckIndexInt = parseInt(assetIndex);
      let assetIndexPass;
      if (assetIndex == 0) {
        assetIndexPass = this.props.subTripPoints.length;
      } else {
        assetIndexPass = assetIndex;
      }

      let element;
      let obj = {};
      if (truckIndexInt !== 0) {
        obj = {
          lat: this.props.subTripPoints[truckIndexInt - 1].lat,
          lng: this.props.subTripPoints[truckIndexInt - 1].lng,
        };
        element = this.props.subTripPoints[truckIndexInt - 1];
      } else {
        obj = {
          lat: this.props.subTripPoints[this.props.subTripPoints.length - 1].lat,
          lng: this.props.subTripPoints[this.props.subTripPoints.length - 1].lng,
        };

        element = this.props.subTripPoints[this.props.subTripPoints.length - 1];
      }
      if (this.props.onItemSelect && element) {
        this.props.onItemSelect(element.name);
      }
      let instruction = `<div style="color:#2296cc;text-transform:uppercase;"><strong>${this.setTripName(
          element.name
        )}</strong></div><div class="bodyContent"><p><span>${
          element.address
        }<br><strong style="color:#55b673;">${
          element.assetName
        }</strong><br><strong>${this.props.reportMode === "trips" ? "Trip Start" : "Arrived"}</strong>: <span>${utcToLocal(
          element.arrived
        )}</span><br><strong>${this.props.reportMode === "trips" ? "Trip End" : "Departed"}</strong>: <span>${element.departed ? utcToLocal(
          element.departed
        ) : (element.isOvernight ? "After midnight" : "Current")}</span><br><strong>${this.props.reportMode === "trips" ? "Journey Time" : "Stop Duration"}</strong>: <span>${
          element.parked
        }</span>${this.props.reportMode === "trips"
          ? `<br><strong>Distance</strong>: <span>${element.distance == null ? "-" : element.distance}</span><br><strong>Odometer</strong>: <span>${element.odometerStart == null ? "-" : element.odometerStart} - ${element.odometerEnd == null ? "-" : element.odometerEnd}</span>`
          : `<br><strong>Stop Type</strong>: <span class="visit-type-pill ${this.getVisitTypePillClass(element)}">${element.visitType || "-"}</span>`}<br><strong>Fridge</strong>: <span>${
          element.fridge
        }</span><br><strong>Temp A</strong>: ${temperatureReadingMarkup(
          element.tempA
        )}<br><strong>Temp B</strong>: ${temperatureReadingMarkup(
          element.tempB
        )}</p></div><div class="info-win-nav not-pop-up"><div class="not-button" onclick="handlePrevious('${
          element.name
        }','${parseInt(assetIndexPass) - 1}')">< ${
          this.setTripNamePre(element.name, parseInt(assetIndexPass) - 1) || ''
        }</div><div  class="not-button" onclick="handleNext('${element.name}','${
          parseInt(assetIndexPass) - 1
        }')">${
          this.setTripNameNext(element.name, parseInt(assetIndexPass) - 1) || ''
        } ></div></div>`;

      this.openBubble(obj, instruction);

      window.map.setCenter(offsetMapLocation(window.map, { lat: element.lat, lng: element.lng }, { y: -100 }));
    };

    // set up containers for the map  + panel
    var mapContainer = document.getElementById("mapContainerVisit");

    //Step 1: initialize communication with the platform
    // In your own code, replace variable window.apikey with your own apikey
    var platform = new window.H.service.Platform({
      apikey: here_api_key,
    });

    let engineType = window.H.Map.EngineType['HARP'];

    var defaultLayers = platform.createDefaultLayers({
      engineType: engineType
    });

    let defaultLayer = defaultLayers.vector.normal.lite;

    //Step 2: initialize a map - this map is centered over Berlin
    let map = new window.H.Map(mapContainer, 
      defaultLayer, {
            engineType: engineType,
      center: { lat: -25.62958, lng: 133.83359 },
      zoom: 4,
      pixelRatio: window.devicePixelRatio || 1,
    });

    // add a resize listener to make sure that the map occupies the whole container
    var viewPort = map.getViewPort();
    viewPort.setPadding(20, 50, 20, 50);

    window.map = map;
    window.addEventListener("resize", () => viewPort.resize());

    // MapEvents enables the event system
    // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
    this.mapBehaviour = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(map));

    var scrollBlock = document.getElementById("mapScrollBlock");

    this.checkCtrl = (event) => {
        if (event.key !== 'Control') return;
        if (event.repeat) return;

        this.ctrlDown = event.type === 'keydown';

        if (this.ctrlDown) {
            this.mapBehaviour.enable(window.H.mapevents.Behavior.WHEELZOOM);
            scrollBlock.classList.add("fade-out");
            scrollBlock.classList.remove("in");
            setTimeout(() => {
              scrollBlock.classList.remove("fade-out");
            }, 300);
        } else if (this.state.scrollLockEnabled) {
            this.mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);
        } else {
            this.mapBehaviour.enable(window.H.mapevents.Behavior.WHEELZOOM);
        }
    }

    // Using global events since we want to capture regardless of where you are on the page
    document.addEventListener('keydown', this.checkCtrl);
    document.addEventListener('keyup', this.checkCtrl);

    mapContainer.addEventListener("mouseenter", this.handleMapMouseEnter);
    mapContainer.addEventListener("mouseleave", this.handleMapMouseLeave);

    // And HERE captures wheel events at the document level so we have to go to the very highest level to undo their mistakes
    this.handleWindowWheel = (event) => {
        if (!this.isMouseOverMap) return;
        if (this.ctrlDown) return;
        if (!this.state.scrollLockEnabled) return;
        if (this.scrollTimer) clearTimeout(this.scrollTimer);

        scrollBlock.classList.remove("fade-out");
        scrollBlock.classList.add('in');
        this.scrollTimer = setTimeout(() => {
            scrollBlock.classList.add("fade-out");
            setTimeout(() => {
              scrollBlock.classList.remove('in');
              scrollBlock.classList.remove("fade-out");
              this.scrollTimer = null;
            }, 300);
        }, 2000);
    };

    window.addEventListener('wheel', this.handleWindowWheel, {
        capture: true,
        passive: true,
    });

    this.applyScrollLock();

    // Create the default UI components
    var ui = window.H.ui.UI.createDefault(map, defaultLayers);

    window.ui = ui;
    window.platform = platform;
    this.drawDepotArea(this.props.depot);
    this.drawExceptionMarkers();
    this.addSubTripPoints(this.props.subTripPoints);
    this.calculateRouteFromAtoB();
    this.drawSelectedTripSegment();
    this.fitMapToRoute();
  }

  componentDidUpdate(prevProps) {
    if (this.props.visitMapPoints !== prevProps.visitMapPoints) {
      this.calculateRouteFromAtoB(window.platform);
      this.fitMapToRoute();
    }

    if (this.props.subTripPoints !== prevProps.subTripPoints) {
      this.addSubTripPoints(this.props.subTripPoints);
      this.calculateRouteFromAtoB(window.platform);
      this.fitMapToRoute();
    }

    if (this.props.selectedItemId !== prevProps.selectedItemId || this.props.reportMode !== prevProps.reportMode) {
      this.addSubTripPoints(this.props.subTripPoints);
      this.drawSelectedTripSegment();
    }

    if (this.props.tripSegments !== prevProps.tripSegments) {
      this.drawSelectedTripSegment();
    }

    if (this.props.depot !== prevProps.depot) {
      this.drawDepotArea(this.props.depot);
    }

    if (this.props.speedExceptions !== prevProps.speedExceptions) {
      this.drawExceptionMarkers();
    }

    if (this.props.selectedExceptionId !== prevProps.selectedExceptionId) {
      if (this.props.selectedExceptionId && !this.state.exceptionsVisible) {
        this.setState({ exceptionsVisible: true }, this.drawExceptionMarkers);
      } else {
        this.drawExceptionMarkers();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.checkCtrl);
    document.removeEventListener('keyup', this.checkCtrl);
    window.removeEventListener('wheel', this.handleWindowWheel, { capture: true });
    const mapContainer = document.getElementById("mapContainerVisit");
    if (mapContainer) {
      mapContainer.removeEventListener("mouseenter", this.handleMapMouseEnter);
      mapContainer.removeEventListener("mouseleave", this.handleMapMouseLeave);
    }
    this.removeMapObject(this.routeGroup);
    this.removeMapObject(this.subTripGroup);
    this.removeMapObject(this.selectedRouteGroup);
    this.removeMapObject(this.depotGroup);
    this.removeMapObject(this.exceptionGroup);
  }

  handleMapMouseEnter = () => {
    this.isMouseOverMap = true;
  };

  handleMapMouseLeave = () => {
    this.isMouseOverMap = false;
  };

  applyScrollLock = () => {
    if (!this.mapBehaviour || !window.H) return;
    if (this.state.scrollLockEnabled) {
      this.mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);
    } else {
      this.mapBehaviour.enable(window.H.mapevents.Behavior.WHEELZOOM);
    }
  };

  handleScrollLockToggle = (event) => {
    this.stopMapControlInteraction(event);
    this.setState(
      (state) => {
        const scrollLockEnabled = !state.scrollLockEnabled;
        localStorage.setItem("visitMapScrollLock", scrollLockEnabled ? "true" : "false");
        return { scrollLockEnabled };
      },
      this.applyScrollLock
    );
  };

  handlePopupDockToggle = (event) => {
    this.stopMapControlInteraction(event);
    this.setState(
      (state) => {
        const popupDocked = !state.popupDocked;
        localStorage.setItem("visitNewPopupDocked", popupDocked ? "true" : "false");
        return {
          popupDocked,
          dockedPopupContent: popupDocked ? this.lastBubbleContent : null,
        };
      },
      () => {
        if (this.state.popupDocked) {
          if (this.bubble) this.bubble.close();
        } else if (this.lastBubblePosition && this.lastBubbleContent) {
          this.openBubble(this.lastBubblePosition, this.lastBubbleContent);
        }
      }
    );
  };

  handleExceptionsToggle = (event) => {
    this.stopMapControlInteraction(event);
    this.setState(
      (state) => ({ exceptionsVisible: !state.exceptionsVisible }),
      this.drawExceptionMarkers
    );
  };

  handleDockedPopupClose = (event) => {
    this.stopMapControlInteraction(event);
    this.lastBubbleContent = null;
    this.lastBubblePosition = null;
    this.setState({ dockedPopupContent: null });
  };

  stopMapControlInteraction = (event) => {
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();
  };

  removeMapObject = (object) => {
    if (window.map && object && window.map.getObjects().indexOf(object) !== -1) {
      window.map.removeObject(object);
    }
  };

  getValidPoint = (point) => {
    if (!point) return null;
    const lat = Number(point.lat);
    const lng = Number(point.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return {
      ...point,
      lat,
      lng,
    };
  };

  getRoutePoints = () => {
    const routePoints = (this.props.visitMapPoints || [])
      .map(this.getValidPoint)
      .filter((point) => point !== null);

    if (routePoints.length > 1) {
      return routePoints;
    }

    return this.getStopPoints();
  };

  getStopPoints = (points) => {
    return (points || this.props.subTripPoints || [])
      .map(this.getValidPoint)
      .filter((point) => point !== null);
  };

  getBearingBetweenPoints = (fromPoint, toPoint) => {
    if (!fromPoint || !toPoint) return 0;
    const startLat = fromPoint.lat * Math.PI / 180;
    const endLat = toPoint.lat * Math.PI / 180;
    const lngDiff = (toPoint.lng - fromPoint.lng) * Math.PI / 180;
    const y = Math.sin(lngDiff) * Math.cos(endLat);
    const x = Math.cos(startLat) * Math.sin(endLat) - Math.sin(startLat) * Math.cos(endLat) * Math.cos(lngDiff);
    return (Math.atan2(y, x) * 180 / Math.PI + 360) % 360;
  };

  getPointBounds = (points) => {
    if (!points || points.length === 0) return null;

    let minLatitude = points[0].lat;
    let maxLatitude = points[0].lat;
    let minLongitude = points[0].lng;
    let maxLongitude = points[0].lng;

    points.forEach((point) => {
      minLatitude = Math.min(minLatitude, point.lat);
      maxLatitude = Math.max(maxLatitude, point.lat);
      minLongitude = Math.min(minLongitude, point.lng);
      maxLongitude = Math.max(maxLongitude, point.lng);
    });

    return new window.H.geo.Rect(maxLatitude, minLongitude, minLatitude, maxLongitude);
  };

  fitMapToRoute = () => {
    if (!window.map || !window.H) return;
    const points = this.getRoutePoints().concat(this.getStopPoints());
    if (points.length === 0) return;

    window.map.getViewPort().resize();

    if (points.length === 1) {
      window.map.setCenter({ lat: points[0].lat, lng: points[0].lng });
      window.map.setZoom(14);
      return;
    }

    const bounds = this.getPointBounds(points);
    if (!bounds) return;

    setTimeout(() => {
      if (!window.map) return;
      window.map.getViewPort().resize();
      window.map.getViewModel().setLookAtData({
        bounds,
        padding: 72,
      });
    }, 0);
  };

  getDepotPoints = (depot) => {
    if (!depot) return [];

    const depotType = String(depot.depotType || depot.DepotType || "").toLowerCase();
    const center = depot.center || depot.Center;
    const locations = depot.locations || depot.Locations || [];

    if (depotType === "circle" && center) {
      const lat = Number(center.latitude ?? center.Latitude);
      const lng = Number(center.longitude ?? center.Longitude);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        return [{ lat, lng }];
      }
      return [];
    }

    return locations
      .map((location) => ({
        lat: Number(location.latitude ?? location.Latitude),
        lng: Number(location.longitude ?? location.Longitude),
      }))
      .filter((point) => Number.isFinite(point.lat) && Number.isFinite(point.lng));
  };

  getDepotBounds = () => {
    if (!this.depotGroup) return null;
    if (typeof this.depotGroup.getBoundingBox === "function") {
      return this.depotGroup.getBoundingBox();
    }
    if (typeof this.depotGroup.getBounds === "function") {
      return this.depotGroup.getBounds();
    }
    if (typeof this.depotGroup.getGeometry === "function") {
      const geometry = this.depotGroup.getGeometry();
      if (geometry && typeof geometry.getBoundingBox === "function") {
        return geometry.getBoundingBox();
      }
    }
    return null;
  };

  centerDepotOnMap = () => {
    if (!window.map || !window.H || !this.props.depot) return;

    const depotPoints = this.getDepotPoints(this.props.depot);
    if (depotPoints.length === 0) return;

    window.map.getViewPort().resize();

    if (depotPoints.length === 1) {
      window.map.getViewModel().setLookAtData({
        position: depotPoints[0],
        zoom: 16,
      });
      return;
    }

    const bounds = this.getDepotBounds() || this.getPointBounds(depotPoints);
    if (bounds) {
      window.map.getViewModel().setLookAtData({
        bounds,
        padding: 100,
      });
    }
  };

  handleCenterDepot = (event) => {
    this.stopMapControlInteraction(event);
    this.centerDepotOnMap();
  };

  handleFitRoute = (event) => {
    this.stopMapControlInteraction(event);
    this.fitMapToRoute();
  };

  setTripName = (name) => {
    return `${this.props.markerLabel || "Trip"} ${name}`;
  };

  setTripNameNext = (name, assetIndex) => {
    let truckIndexInt = parseInt(assetIndex);

    if (truckIndexInt < this.props.subTripPoints.length - 1) {
      let element = this.props.subTripPoints[truckIndexInt + 1];

      return `${this.props.markerLabel || "Trip"} ${element.name}`;
    } else {
      let element = this.props.subTripPoints[0];

      return `${this.props.markerLabel || "Trip"} ${element.name}`;
    }
  };

  setTripNamePre = (name, assetIndex) => {
    let truckIndexInt = parseInt(assetIndex);

    if (truckIndexInt !== 0) {
      let element = this.props.subTripPoints[truckIndexInt - 1];

      return `${this.props.markerLabel || "Trip"} ${element.name}`;
    } else {
      let element = this.props.subTripPoints[
        this.props.subTripPoints.length - 1
      ];

      return `${this.props.markerLabel || "Trip"} ${element.name}`;
    }
  };

  addSubTripPoints = (data) => {
    this.removeMapObject(this.subTripGroup);
    this.subTripGroup = new window.H.map.Group();
    let selectedMarker = null;
    this.getStopPoints(data).forEach((element, assetIndex) => {
      const isSelected = String(this.props.selectedItemId) === String(element.name);
      // Create flag icon
      const flagIcon = new window.H.map.Icon(
        this.createFlagMarker(element.name, isSelected),
        {
          size: { w: 56, h: 49 },
          anchor: { x: 0, y: 49 },
        }
      );
      var marker = new window.H.map.Marker(
        {
          lat: element.lat,
          lng: element.lng,
        },
        { icon: flagIcon }
      );

      this.subTripGroup.addObject(marker);
      marker.setZIndex(isSelected ? 10000 : assetIndex + 1);
      marker.selectionId = String(element.name);
      marker.instruction = `<div style="color:#2296cc;text-transform:uppercase;"><strong>${this.setTripName(
          element.name
        )}</strong></div><div class="bodyContent"><p><span>${
          element.address
        }<br><strong style="color:#55b673;">${
          element.assetName
        }</strong><br><strong>${this.props.reportMode === "trips" ? "Trip Start" : "Arrived"}</strong>: <span>${utcToLocal(
          element.arrived
        )}</span><br><strong>${this.props.reportMode === "trips" ? "Trip End" : "Departed"}</strong>: <span>${element.departed ? utcToLocal(
          element.departed
        ) : (element.isOvernight ? "After midnight" : "Current")}</span><br><strong>${this.props.reportMode === "trips" ? "Journey Time" : "Stop Duration"}</strong>: <span>${
          element.parked
        }</span>${this.props.reportMode === "trips"
          ? `<br><strong>Distance</strong>: <span>${element.distance == null ? "-" : element.distance}</span><br><strong>Odometer</strong>: <span>${element.odometerStart == null ? "-" : element.odometerStart} - ${element.odometerEnd == null ? "-" : element.odometerEnd}</span>`
          : `<br><strong>Stop Type</strong>: <span class="visit-type-pill ${this.getVisitTypePillClass(element)}">${element.visitType || "-"}</span>`}<br><strong>Fridge</strong>: <span>${
          element.fridge
        }</span><br><strong>Temp A</strong>: ${temperatureReadingMarkup(
          element.tempA
        )}<br><strong>Temp B</strong>: ${temperatureReadingMarkup(
          element.tempB
        )}</p></div><div class="info-win-nav not-pop-up"><div class="not-button" onclick="handlePrevious('${
          element.name
        }','${assetIndex}')">< ${
          this.setTripNamePre(element.name, assetIndex) || ''
        }</div><div class="not-button"  onclick="handleNext('${
          element.name
        }','${assetIndex}')">${
          this.setTripNameNext(element.name, assetIndex) || ''
        } ></div></div>`;
      if (isSelected) selectedMarker = marker;
    });

    this.subTripGroup.addEventListener("tap", (evt) => {
      if (this.props.onItemSelect && evt.target.selectionId) {
        this.props.onItemSelect(evt.target.selectionId);
      }
      window.map.setCenter(offsetMapLocation(window.map, evt.target.getGeometry(), { y: -100 }));
      this.openBubble(evt.target.getGeometry(), evt.target.instruction);
    }, false);

    // Add the maneuvers group to the map
    window.map.addObject(this.subTripGroup);
    if (selectedMarker) {
      const geometry = selectedMarker.getGeometry();
      window.map.setCenter(offsetMapLocation(window.map, geometry, { y: -100 }), true);
      this.openBubble(geometry, selectedMarker.instruction);
    }
  };

  calculateRouteFromAtoB = async () => {
    let point = this.getRoutePoints();

    this.drawRoute(point);
    this.drawRouteMarkers();
  };

  /*
   * Draw route using points matched by here maps routing api
   */
  drawRoute = (points) => {
    this.removeMapObject(this.routeGroup);
    this.routeGroup = new window.H.map.Group();

    if (!points || points.length <= 1) {
      return;
    }

    let lineString = new window.H.geo.LineString();
    let polyline;
    points.forEach((point) => {
      lineString.pushLatLngAlt(point.lat,point.lng);
    });

    polyline = new window.H.map.Polyline(lineString, {
      style: {
        lineWidth: 3,
        strokeColor: "rgba(239, 93, 231, 0.8)",
      },
    });

    // Add the polyline to the map
    this.routeGroup.addObject(polyline);
  };

  drawSelectedTripSegment = () => {
    this.removeMapObject(this.selectedRouteGroup);
    this.selectedRouteGroup = null;

    if (this.props.reportMode !== "trips" || !this.props.selectedItemId || !window.map || !window.H) {
      return;
    }

    const segment = (this.props.tripSegments || []).find(
      (item) => String(item.tripId) === String(this.props.selectedItemId)
    );
    const points = ((segment && segment.points) || [])
      .map((point) => ({ lat: Number(point.latitude), lng: Number(point.longitude) }))
      .filter((point) => Number.isFinite(point.lat) && Number.isFinite(point.lng));

    if (points.length < 2) return;

    const lineString = new window.H.geo.LineString();
    points.forEach((point) => lineString.pushLatLngAlt(point.lat, point.lng));
    const polyline = new window.H.map.Polyline(lineString, {
      style: {
        lineWidth: 8,
        strokeColor: "rgba(255, 84, 57, 0.95)",
        lineCap: "round",
        lineJoin: "round",
      },
    });

    this.selectedRouteGroup = new window.H.map.Group();
    this.selectedRouteGroup.addObject(polyline);
    window.map.addObject(this.selectedRouteGroup);

    const bounds = this.getPointBounds(points);
    if (bounds) {
      window.map.getViewModel().setLookAtData({ bounds, padding: 100 }, true);
    }
  };

  /**
   * Creates a series of H.map.Marker points from the route and adds them to the map.
   */
  drawRouteMarkers = () => {
    if (!this.routeGroup) {
      this.routeGroup = new window.H.map.Group();
    }

    const routePoints = this.getRoutePoints();
    if (routePoints.length === 0) return;

    let startIcon = new window.H.map.Icon(this.createStartMarker(), {
      size: { w: 40, h: 64 },
      anchor: { x: 20, y: 64 },
    });
    let endIcon = new window.H.map.Icon(this.createEndMarker(), {
      size: { w: 32, h: 32 },
      anchor: { x: 16, y: 16 },
    });

    let lastArrowPoint = routePoints[0];
    routePoints.forEach((element, index) => {
      if (index === 0) {
        // Start marker
        var marker = new window.H.map.Marker(
          {
            lat: element.lat,
            lng: element.lng,
          },
          { icon: startIcon }
        );

        marker.first = true;
        marker.instruction = `<p><span>${
            element.name
          }<br> 7-8 Acorn Ct<br> Dry Creek SA 5094<br> Australia</span><br><strong style="color:#d6af15;">${
            element.assetName
          }</strong><br><strong>Received</strong>: <span>${utcToLocal(
            element.recieved
          )}</span><br><strong>Parked</strong>: <span>${
            element.parked
          }</span><br><strong>Speed</strong>: <span>${
            element.speed
          }</span><br><strong>Fridge</strong>: <span>Off</span><br><strong>Temp A</strong>: <span></span><br><strong>Temp B</strong>: <span></span></p>`;

        this.routeGroup.addObject(marker);
      } else if (index === routePoints.length - 1) {
        let marker = new window.H.map.Marker(
          {
            lat: element.lat,
            lng: element.lng,
          },
          { icon: endIcon }
        );

        this.routeGroup.addObject(marker);
      } else {
        // Create arrow
        // Distribute arrows across zoom levels (Arrive at a fraction between 0 and 1. Using sine for distribution)
        const distanceFromLastArrow = Math.sqrt(Math.pow(element.lat - lastArrowPoint.lat, 2) + Math.pow(element.lng - lastArrowPoint.lng, 2));
        if (distanceFromLastArrow < 0.004 && index % 12 !== 0) return;
        lastArrowPoint = element;
        const angle = Number.isFinite(Number(element.angle)) ? Number(element.angle) : this.getBearingBetweenPoints(routePoints[index - 1], element);
        const arrowIcon = new window.H.map.Icon(
          this.createArrowMarker(angle),
          {
            size: { w: 24, h: 24 },
            anchor: { x: 12, y: 12 },
          }
        );
        let marker = new window.H.map.Marker(
          {
            lat: element.lat,
            lng: element.lng,
          },
          { icon: arrowIcon }
        );

        this.routeGroup.addObject(marker);
      }
    });

    this.routeGroup.addEventListener("tap", (evt) => {
      window.map.setCenter(evt.target.getGeometry());
    }, false);

    // Add the maneuvers group to the map
    window.map.addObject(this.routeGroup);
  };

  drawDepotArea = (depot) => {
    this.removeMapObject(this.depotGroup);
    this.depotGroup = null;
    if (!depot) return;
    this.depotGroup = drawDepot(window.map, depot);
  }

  drawExceptionMarkers = () => {
    this.removeMapObject(this.exceptionGroup);
    this.exceptionGroup = null;
    if (!this.state.exceptionsVisible || !window.map || !window.H) return;

    const validExceptions = (this.props.speedExceptions || []).map((item, index) => ({
      item,
      id: String(index + 1),
      lat: Number(item.latitude),
      lng: Number(item.longitude),
    })).filter((entry) => Number.isFinite(entry.lat) && Number.isFinite(entry.lng));

    if (validExceptions.length === 0) return;
    this.exceptionGroup = new window.H.map.Group();
    let selectedMarker = null;

    validExceptions.forEach((entry) => {
      const selected = String(this.props.selectedExceptionId) === entry.id;
      const icon = new window.H.map.Icon(this.createExceptionMarker(entry.item.startSpeedLimit, selected), {
        size: { w: 40, h: 55 },
        anchor: { x: 20, y: 53 },
      });
      const marker = new window.H.map.Marker({ lat: entry.lat, lng: entry.lng }, { icon });
      const item = entry.item;
      marker.exceptionId = entry.id;
      marker.setZIndex(selected ? 9000 : 1);
      marker.instruction = `<div style="color:#b91c1c;text-transform:uppercase;"><strong>Overspeed Exception ${entry.id}</strong></div><div class="bodyContent"><p><strong>Type</strong>: <span>${item.type || "-"}</span><br><strong>Started</strong>: <span>${utcToLocal(item.started)}</span><br><strong>Completed</strong>: <span>${utcToLocal(item.completed)}</span><br><strong>Duration</strong>: <span>${item.duration || "-"}</span><br><strong>Start Speed</strong>: <span>${item.startSpeed == null ? "-" : Number(item.startSpeed).toFixed(2)}</span><br><strong>Speed Limit</strong>: <span>${item.startSpeedLimit == null ? "-" : item.startSpeedLimit}</span><br><strong>End Speed</strong>: <span>${item.endSpeed == null ? "-" : Number(item.endSpeed).toFixed(2)}</span><br><strong>End Speed Limit</strong>: <span>${item.endSpeedLimit == null ? "-" : item.endSpeedLimit}</span></p></div>`;
      this.exceptionGroup.addObject(marker);
      if (selected) selectedMarker = marker;
    });

    this.exceptionGroup.addEventListener("tap", (event) => {
      const marker = event.target;
      if (this.props.onExceptionSelect) this.props.onExceptionSelect(marker.exceptionId);
      this.openBubble(marker.getGeometry(), marker.instruction);
    }, false);
    window.map.addObject(this.exceptionGroup);

    if (selectedMarker) {
      window.map.setCenter(offsetMapLocation(window.map, selectedMarker.getGeometry(), { y: -100 }), true);
      this.openBubble(selectedMarker.getGeometry(), selectedMarker.instruction);
    }
  };

  bubble;
  lastBubblePosition = null;
  lastBubbleContent = null;

  openBubble = (position, text) => {
    this.lastBubblePosition = position;
    this.lastBubbleContent = text;

    if (this.props.allowDockedPopup && this.state.popupDocked) {
      if (this.bubble) this.bubble.close();
      this.setState({ dockedPopupContent: text });
      return;
    }

    if (!this.bubble) {
      this.bubble = new window.H.ui.InfoBubble(
        position,
        // The FO property holds the province name.
        { content: text }
      );
      window.ui.addBubble(this.bubble);
    } else {
      this.bubble.setPosition(position);
      this.bubble.setContent(text);
      this.bubble.open();
    }
  };

  onError = (error) => {
    alert("Can't reach the remote server");
  };

  handleFullScreen = () => {
    $("#mapContainerVisit")[0].requestFullscreen();
  };

  handleFullScreenClick = (event) => {
    this.stopMapControlInteraction(event);
    this.handleFullScreen();
  };

  renderMapControls = () => {
    const scrollLockEnabled = !!this.state.scrollLockEnabled;
    const hasDepot = this.getDepotPoints(this.props.depot).length > 0;
    const hasRoute = this.getRoutePoints().concat(this.getStopPoints()).length > 0;

    return (
      <div
        className="visit-map-controls"
        onMouseDown={this.stopMapControlInteraction}
        onTouchStart={this.stopMapControlInteraction}
        onWheel={this.stopMapControlInteraction}
      >
        <button
          type="button"
          className="visit-map-control-button active"
          onClick={this.handleFullScreenClick}
          title="Open map fullscreen"
        >
          <i className="fa fa-expand"></i>
        </button>
        <button
          type="button"
          className={scrollLockEnabled ? "visit-map-control-button active" : "visit-map-control-button"}
          onClick={this.handleScrollLockToggle}
          title={scrollLockEnabled ? "Scroll lock on" : "Scroll lock off"}
        >
          <i className={scrollLockEnabled ? "fa fa-lock" : "fa fa-unlock"}></i>
        </button>
        {this.props.allowDockedPopup && (
          <button
            type="button"
            className={this.state.popupDocked ? "visit-map-control-button active" : "visit-map-control-button"}
            onClick={this.handlePopupDockToggle}
            title={this.state.popupDocked ? "Show popup on map" : "Move popup to left panel"}
          >
            <i className="fa fa-columns"></i>
          </button>
        )}
        {this.props.allowDockedPopup && (
          <button
            type="button"
            className={this.state.exceptionsVisible ? "visit-map-control-button active" : "visit-map-control-button"}
            onClick={this.handleExceptionsToggle}
            disabled={(this.props.speedExceptions || []).length === 0}
            title={(this.props.speedExceptions || []).length > 0 ? `${this.state.exceptionsVisible ? "Hide" : "Show"} overspeed exceptions` : "No overspeed exceptions"}
          >
            <i className="fa fa-tachometer"></i>
            {(this.props.speedExceptions || []).length > 0 && <span className="visit-map-control-count">{this.props.speedExceptions.length}</span>}
          </button>
        )}
        <button
          type="button"
          className="visit-map-control-button"
          onClick={this.handleCenterDepot}
          disabled={!hasDepot}
          title={hasDepot ? "Centre depot" : "No depot boundary available"}
        >
          <i className="fa fa-map-marker"></i>
        </button>
        <button
          type="button"
          className="visit-map-control-button"
          onClick={this.handleFitRoute}
          disabled={!hasRoute}
          title={hasRoute ? "Fit route to map" : "No route available"}
        >
          <i className="fa fa-crosshairs"></i>
        </button>
      </div>
    );
  };

  renderDockedPopup = () => {
    if (!this.props.allowDockedPopup || !this.state.popupDocked || !this.state.dockedPopupContent) {
      return null;
    }

    return (
      <aside className="visit-map-popup-panel" aria-label="Selected map item details">
        <button
          type="button"
          className="visit-map-popup-close"
          onClick={this.handleDockedPopupClose}
          aria-label="Close selected item details"
          title="Close"
        >
          <i className="fa fa-times"></i>
        </button>
        <div dangerouslySetInnerHTML={{ __html: this.state.dockedPopupContent }} />
      </aside>
    );
  };

  render() {
    return (
      <React.Fragment>
        <div id="mapContainerVisit" tabIndex="0">
          {this.renderMapControls()}
          {this.renderDockedPopup()}
          <div id="mapScrollBlock">
            {this.state.scrollLockEnabled && (
              <div className="map-scroll-message">
                Hold Ctrl + scroll to zoom the map
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default VisitMap;
